import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useHasRole } from "../hooks/useHasRole";

interface RoleRouteProps {
  role: string;
  children: ReactNode;
}

/**
 * Renders its children only when the current user has the given role.
 * Otherwise redirects to the home route, mirroring how the app gates
 * unauthorized users in AppRouter.
 */
const RoleRoute = ({ role, children }: RoleRouteProps) => {
  const hasRole = useHasRole(role);

  if (!hasRole) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default RoleRoute;
